import { createSelector } from '@ngrx/store'
import { SharedConfig } from '../../../shared/shared.config'
import { selectSharedConfig } from '../../config/config.selectors'
import { isAgentAppId } from '../../ui/ui.utils'
import {
  selectAuthenticatedViaPasskey,
  selectIsPasskeySupported,
  selectIsRapUser,
  selectPasskeyPromptDismissed,
} from '../auth.selectors'

export const selectShouldOfferPasskeyRegistration = createSelector(
  selectIsPasskeySupported,
  selectIsRapUser,
  selectSharedConfig,
  selectAuthenticatedViaPasskey,
  selectPasskeyPromptDismissed,
  (
    supported: boolean,
    isRap: boolean,
    sharedConfig: SharedConfig,
    viaPasskey: boolean,
    dismissed: boolean
  ): boolean =>
    supported &&
    !isRap &&
    !isAgentAppId() &&
    !viaPasskey &&
    !dismissed &&
    !sharedConfig?.nativeAppView
)
